

export class Group{

  id:number;
  name:string;
  department:string;
    
  constructor(object = null){
    if(object){
      this.set(object);
    }
  };

  set(object){
    if(object.id){
      this.id = Number(object.id);
    }
    if(object.name){
      this.name = object.name;
    }
    if(object.department){
      this.department = object.department;
    }

  }
}
  
  